var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { customElement, property } from 'lit/decorators.js';
let SpinnerComponent = class SpinnerComponent extends GGOBaseComponent {
    constructor() {
        super();
        this.size = 'x-small';
    }
    render() {
        return html `<div class="demo-only" style="height:6rem;position:relative">
      <div class="slds-spinner_container">
        <div role="status" class="slds-spinner slds-spinner_${this.size} slds-spinner_brand">
          <span class="slds-assistive-text">Loading</span>
          <div class="slds-spinner__dot-a"></div>
          <div class="slds-spinner__dot-b"></div>
        </div>
      </div>
    </div>`;
    }
};
__decorate([
    property({ type: String })
], SpinnerComponent.prototype, "size", void 0);
SpinnerComponent = __decorate([
    customElement('ggo-spinner')
], SpinnerComponent);
export { SpinnerComponent };
